/* src/app/shared/ui/loader/loader.component.scss */
.dominos-loader {
  position: fixed;
  inset: 0;
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.35);
}
.dominos-spinner {
  width: 64px;
  height: 64px;
  animation: dominos-rotate 1s linear infinite;
}
.dominos-spinner__circle {
  fill: none;
  stroke: #FF0000;
  stroke-width: 5;
  stroke-linecap: round;
  stroke-dasharray: 5 95;
  stroke-dashoffset: 0;
  animation: dominos-line 1.4s ease-in-out infinite, dominos-color 2.8s ease-in-out infinite;
}
@keyframes dominos-rotate {
  to {
    transform: rotate(360deg);
  }
}
@keyframes dominos-line {
  0% {
    stroke-dasharray: 5 95;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 80 20;
    stroke-dashoffset: -25;
  }
  100% {
    stroke-dasharray: 5 95;
    stroke-dashoffset: -100;
  }
}
@keyframes dominos-color {
  0%, 45% {
    stroke: #FF0000;
  }
  50%, 95% {
    stroke: #0090E2;
  }
  100% {
    stroke: #FF0000;
  }
}
/*# sourceMappingURL=loader.component.css.map */
